export default __webpack_public_path__ + "static/media/iphonebatterysignale.b277ad7f.png";